import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../../../theme/colors";

const useStyles = makeStyles((theme) => ({
  paperRounded: {
    borderRadius: 12,
  },
  dialogBox: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    width: 870,
    maxWidth: "100%",
    padding: "16px 0px 24px",
    background: colors.white,
    fontFamily: "Roboto",
  },
  closeRow: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "0px 32px",
  },
  closeBtn: {
    width: 18,
    height: 18,
  },
  closeBtnIcon: {
    width: 18,
    height: 18,
    stroke: colors.darkBlue900,
  },
  content: {
    display: "flex",
    alignItems: "stretch",
    gap: 32,
    padding: "0px 32px",
    minHeight: 482,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      minHeight: "auto",
    },
  },
  modal: {
    boxSizing: "border-box",
    display: "flex",
    flex: "1 1 calc(50% - 16px)",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: 32,
    padding: "24px 24px 24px 48px",
    background: colors.lightBlueGradient,
    borderRadius: 12,
    [theme.breakpoints.down("sm")]: {
      padding: 24,
    },
  },
  modalLogo: {
    width: 216,
    maxWidth: "100%",
  },
  modalText: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  modalTitle: {
    fontFamily: "Roboto",
    fontWeight: 700,
    fontSize: 24,
    lineHeight: "34px",
    color: colors.darkBlue900,
  },
  modalDescription: {
    fontFamily: "Roboto",
    fontSize: 20,
    lineHeight: "32px",
    color: colors.ideBlack900,
  },
  options: {
    margin: "15px 0px 15px 0px",
    boxSizing: "border-box",
    display: "flex",
    flex: "1 1 calc(50% - 16px)",
    flexDirection: "column",
    justifyContent: "center",
    gap: 16,
    minWidth: 0,
  },
  question: {
    fontFamily: "Roboto",
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "32px",
    color: colors.darkBlue900,
  },
  optionCard: {
    flex: 1,
  },
}));

export { useStyles };
